import { useCallback, useEffect, useState } from "react";

import DistributionReviewApi from "../../../infrastructure/api/distributionReview";
import { getSelectedDistributionCompanyId } from "./DistributionCompanySelect";

export const pick = (obj, ...keys) => {
  for (const k of keys) {
    if (obj?.[k] != null) return obj[k];
  }
  return undefined;
};

const useDistributionPortalContext = () => {
  const [selectedCompanyId, setSelectedCompanyId] = useState(
    getSelectedDistributionCompanyId
  );
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await DistributionReviewApi.getPortalContext(selectedCompanyId);
      const ctx = res?.data ?? res?.Data ?? null;
      setContext(ctx);
      return ctx;
    } catch (e) {
      setError(e?.message || "خطا در دریافت اطلاعات شرکت توزیع");
      return null;
    } finally {
      setLoading(false);
    }
  }, [selectedCompanyId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    context,
    companyId: pick(context, "distributionCompanyId", "DistributionCompanyId") || null,
    companyName: pick(context, "distributionCompanyName", "DistributionCompanyName"),
    isCompanyAdmin: pick(context, "isCompanyAdmin", "IsCompanyAdmin") === true,
    setSelectedCompanyId,
    reload,
    loading,
    error,
  };
};

export default useDistributionPortalContext;
